<template>
  <div class="app-container">
    <KcHeader />
    <KcMain />
    <KcFooter />
  </div>
</template>

<script>
import KcHeader from '@/components/lianmeng/common/KcHeader.vue'
import KcFooter from '@/components/lianmeng/common/KcFooter.vue'
import KcMain from "@/components/lianmeng/common/KcMain";

export default {
  name: 'App',
  components: {
    KcHeader,
    KcMain,
    KcFooter
  }
}
</script>

<style>
/* 全局布局样式 */
.app-container {
  display: flex;
  flex-direction: column;
  min-width: 1200px;
  min-height:100vh;
}

</style>
